import axios from "axios";


export default axios.create({
    baseURL: "https://15wjwxx0uf.execute-api.eu-west-3.amazonaws.com/dev/\n"
})